import styled from 'styled-components';
import { ActionsBanner } from '~/components';
import { navGap, navWidth } from './navLayout';

export default styled(ActionsBanner)`
  margin-left: calc(-1 * (${navWidth} + ${navGap} + 1rem));
`;
